import { View } from 'ol';
import { Rotate, Zoom } from 'ol/control';
import { Extent, getCenter } from 'ol/extent';
import { register } from 'ol/proj/proj4';

import proj4 from 'proj4';

proj4.defs('EPSG:3006', '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=enu');
register(proj4);

export const lantmaterietExtent: Extent = [-1200000, 4305696, 2994304, 8500000];
export const epsg3006Extent: Extent = [181896.32913603852, 6091282.433471196, 1086312.9422175875, 7689478.305598114];
// Ej den definierade sweref 99 bboxen, utan med angränsande zon (Används för validering i common)
export const epsg3006ExtentExtended: Extent = [223000, 6090000, 923000, 7674000];
export const resolutionsWmts = [4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5];
const resolutionsWms = [0.25, 0.125, 0.0625, 0.03125];
export const resolutions = [...resolutionsWmts, ...resolutionsWms];
export const projection = 'EPSG:3006';

const olZoomClasses = 'ol-zoom tw-flex tw-flex-col tw-gap-2 tw-absolute tw-right-0 tw-bottom-0 tw-p-4 tw-mb-5';
const olRotationClasses =
  'ol-rotate tw-flex tw-flex-col !tw-rounded-full tw-absolute tw-top-[8rem] tw-right-0 tw-p-4 tw-mb-5 tw-rotate-[-45deg]';

const rotationsButtonElement = document.createElement('span');
rotationsButtonElement.className = 'raa-icon-compass';

export const view = new View({
  zoom: 1,
  resolutions,
  projection,
  extent: epsg3006Extent,
  center: getCenter(epsg3006Extent),
  minZoom: 1,
  constrainOnlyCenter: true,
  smoothExtentConstraint: true,
  showFullExtent: true
});

export const controls = [
  new Rotate({
    className: olRotationClasses,
    label: rotationsButtonElement,
    autoHide: true,
    tipLabel: 'Återställ kartrotation'
  }),
  new Zoom({
    className: olZoomClasses,
    zoomInTipLabel: 'Zooma in',
    zoomOutTipLabel: 'Zooma ut',
    zoomInClassName: 'map-toolbar-button',
    zoomOutClassName: 'map-toolbar-button'
  })
];
